<template>
	<div :style="outerStyle" class="outfitmodal">
		<div class="modal-wrapper stylingViewModelClass">
			<div class="view-modal-buttons flex flex-column">
        <button
					class="remove-button bg-red"
					v-bind:class="{'bg-warning': changedLetter}"
					v-on:click="$emit('removeBox')">
						Remove
				</button>
				<button class="new-cancel-button bg-dark-grey" v-on:click="$emit('close')">CANCEL</button>
			</div>
			<div class="view-modal-content stylingView" style="max-height:auto !important; height: 100%;width: 100%;display: flex; flex-direction: row;">
                <div style="width: 50%;background: #fff; overflow-y: scroll; position: relative;padding:30px;">
                    <div>
                        <div v-if="markdownToHtml === ''">
                            <h2>What the customer feels is missing in the box</h2>
                            <div v-if="styling !== null && styling.comment !== ''">{{ styling.comment }}</div>
                            <div v-else>N/A</div>

                            <h2>Customer comment</h2>
                            <div v-if="survey !== null && survey.other_to_know !== null && survey.other_to_know !== ''">{{ survey.other_to_know }}</div>
                            <div v-else>N/A</div>
                        </div>

                        <div v-else>
                            <div v-if="styling !== null && styling.comment !== ''"
                            style="margin-bottom: 40px;">
                                <h2>What the customer feels is missing in the box</h2>
                                <div>{{ styling.comment}}</div>
                            </div>
                            <div v-html="markdownToHtml"></div>
                        </div>
                    </div>
                </div>
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
import MarkdownIt from 'markdown-it';

export default {
  name: 'StylingViewModal',
  props: {
    modalWidth: {
      type: Number,
      default: 700
    },
    isLetter: {
	    type: Boolean,
	    default: false
    },
    changedLetter: {
	    type: Boolean,
	    default: false
    },
    summary: {
        type: String,
        default: ""
    },
    survey: {
        type: Object,
        default: null
    },
    styling: {
        type: Object,
        default: null
    }
  },
  data () {
    return {
	  zoom: 100,
      markdownSummary: '',
      md: new MarkdownIt()
    }
  },
  mounted () {
    this.autoSetZoom()
    window.addEventListener('resize', () => {
      this.autoSetZoom()
    })
  },
  computed: {
    markdownToHtml() {
        return this.md.render(this.summary);
    },

    outerStyle () {
      return 'zoom: ' + this.zoom + '%;'
    }
  },
  methods: {
    autoSetZoom () {
	  var modalMargin = 300
	  if (this.modalWidth + modalMargin > window.innerWidth) {
        var screenWidth = window.innerWidth - modalMargin
        var zoomSuggest = Math.round((screenWidth / this.modalWidth) * 100)
      	this.zoom = zoomSuggest
	  }
    }
  }
}
</script>
